import {combineReducers} from "redux";
import {commonReducerFor, initialState as commonInitialState} from "../../../Redux/CommonReducer";
import {pollsReducer, initialState as pollsInitialState} from "./PollsReducer";

export const pollsModuleSliceReducer = combineReducers({
    common: commonReducerFor('POLLS'),
    polls: pollsReducer,
});

export const initialState = {
    common: commonInitialState,
    polls: pollsInitialState,
}
